import request from "../plugins/request";

// 预警档案列表
export const getArchivesPage = (data) => {
  return request({
    url: '/api/warning/archives/page',
    method: 'get',
    params: data
  })
}

export const getWarningList = (data) => {
  return request({
    url: '/api/warning/event/page',
    method: 'get',
    loading: true,
    params: data
  })
}

// 预警上报（启动预警）
export const manualReportWarning = (data) => {
  return request({
    url: '/api/warning/manualReportWarning',
    method: 'post',
    data: data
  })
}

// 预警事件处理
export const warningProcess = (data) => {
  return request({
    url: '/api/warning/process',
    method: 'post',
    data: data
  })
}

// 预警事件详情
export const warningDetail = (params) => {
  return request({
    url: '/api/warning/detail',
    method: 'get',
    loading: true,
    params: params
  })
}

// 解除预警（批量）
export const rescindBatch = (data) => {
  return request({
    url: '/api/warning/rescindBatch',
    method: 'post',
    loading: true,
    data: data
  })
}

// 删除预警（批量）
export const removeBatch = (data) => {
  return request({
    url: '/api/warning/removeBatch',
    method: 'post',
    loading: true,
    data: data
  })
}
